import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Logo from "../utils/salesDood2.png";

const LoginPage = () => {

  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths") ? JSON.parse( localStorage.getItem("apiPaths") ) : "-"
  
  const [loginUserName, setLoginUserName] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); // Error state
  console.log('loginUserName:', loginUserName)
  console.log('password:', password)
  const navigate = useNavigate();


  const checkIfAlreadyLoggedIn = () => {

    let token = false;

    const loginStatus = localStorage.getItem("currentUserLoginStatus")

    if (loginStatus) {
      if (JSON.parse(loginStatus)) {
        token = true
      }
    }

    if (token) {
      navigate("/leads")
    }
  }


  const getApiPaths = async () => {

   let result =  new Promise((resolve) => {
      axios.get(`https://cubixweberp.com:301/api/clientmanager/${company_code_from_local_storage}`).then((res) => {

        if (res.data?.length > 0) {
          localStorage.setItem("apiPaths", JSON.stringify(res.data));
          resolve(true)
        } else {
          localStorage.setItem("apiPaths", JSON.stringify([]));
          resolve(false)
        }

      }).catch((err) => {
        resolve(false)
      })

    })

    let returnResultOfAPIPath = await result
    return returnResultOfAPIPath

  }


  const getApiPathAndLoginCheck = async () => {

    console.log("Inside LoginPage component")

    console.log("calling api path ")
    //first call cubot api to get api url , image saving retrieving path etc placed the function here because if any change in this api path , user just have to logout and login then it will be reset in local storage 
    let result = await getApiPaths()

    console.log(" result of api path", result)

    checkIfAlreadyLoggedIn()

  }

  useEffect(() => {

    getApiPathAndLoginCheck()

  }, [])

  const handleLogin = async (e) => {
    e.preventDefault(); // Prevent form from refreshing
    try {
      const apiurl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/LoginUser?user=${loginUserName}&pass=${password}&cmpcode=${company_code_from_local_storage}`

      console.log("apiurl login >>>", apiurl)
      const response = await axios.get(
        apiurl
      );

      const loginData = response.data;
      console.log("Success! loginData:", loginData);

      const successUser = loginData.find((user) => user.Userlogin === "Sucess");
      const userEmployeeID = loginData[0]?.EMPID;
      const userFirstDeptNo = loginData[0]?.DEPTNO;

      console.log("Success! loginDept:", userFirstDeptNo);

      if (successUser) {
        if (userFirstDeptNo && userFirstDeptNo.trim() !== "") {
          localStorage.setItem("currentUser", JSON.stringify(loginData));
          localStorage.setItem("currentUserName", loginUserName?.trim());
          localStorage.setItem("currentUserEmployeeID", userEmployeeID?.trim());
          localStorage.setItem("currentSelectedDepartment", userFirstDeptNo?.trim());
          localStorage.setItem("currentUserLoginStatus", JSON.stringify(true))

          navigate("/leads"); // Navigate to the homepage on successful login
        } else {
          // Show snackbar if DEPTNO is missing
          setErrorMessage("Department number is missing. Please contact admin.");
        }
      } else {
        setErrorMessage("Invalid credentials. Please try again.");
      }
    } catch (error) {
      console.error("Error while logging in:", error);
      setErrorMessage("Login failed. Please check your credentials.");
    }
  }

  return (
    <div className="flex items-center justify-center min-h-screen z-30">
      {/* <img src={Logo} alt="salesdood-logo" className="w-120 h-108 mx-auto mb-4" /> */}
      <div className="w-full max-w-md p-8 bg-white  rounded-lg shadow-lg">
        <img src={Logo} alt="salesdood-logo" className="w-120 h-8 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-center text-gray-700">Login</h2>

        {errorMessage && (
          <p className="text-red-500 text-sm text-center mt-2">{errorMessage}</p>
        )}

        <form onSubmit={handleLogin} className="mt-6">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Username
            </label>
            <input
              type="text"
              className="w-full px-4 py-2 mt-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              placeholder="Enter your username"
              value={loginUserName}
              onChange={(e) => setLoginUserName(e.target.value)}
              required
            />
          </div>

          <div className="mt-4">
            <label className="block text-sm font-medium text-gray-700">
              Password
            </label>
            <input
              type="password"
              className="w-full px-4 py-2 mt-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="flex justify-between items-center mt-4">
            <button type="button" className="text-sm text-blue-600 hover:underline">
              Forgot Password?
            </button>
          </div>

          <button
            type="submit"
            className="w-full mt-6 py-2 text-white bg-blue-500 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
          >
            Login
          </button>
        </form>

        <p className="mt-4 text-sm text-center">
          Don't have an account?{" "}
          <button type="button" className="text-blue-600 hover:underline">
            Sign up
          </button>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
